"use client";
import Select from "@/components/primitives/select";
import { generateYearOptions } from "@/utils";
import { useParamUpdater } from "@/utils/hooks/navigation";
import { Sport, getDefaultYear } from "common";
import { useRouter } from "next-nprogress-bar";
import React from "react";

export default function TeamOverviewFilter({
  params,
}: {
  params: { sport: Sport; year: string };
}) {
    const { createParamString } = useParamUpdater();
    const router = useRouter();
  return (
    <Select
      label="Year"
      value={params.year}
      options={generateYearOptions(
        params.sport,
        getDefaultYear(params.sport),
        4,
      )}
      onValueChange={(v: string) =>
        router.replace(createParamString(v, 3) || params.year, {
          scroll: false,
        })
      }
      variant="team-sm"
    />
  );
}
